export default {
    data: () => ({
    }),
    methods: {
    }
}